module.exports = __webpack_public_path__ + "static/media/purple-blob.58d44b39.png";